import React from "react";
import ClassNames from "classnames";
import Tooltip from "../Tooltip/Tooltip";
import { SCALE_COLOR_MAP } from "../scaleColors";
import "./ValuesScale.scss";

export const MAX_VALUES_SCALE_SEGMENTS = 5;

export interface ValuesScaleProps {
  items: string[];
  selectedValue?: string;
  title?: string;
  infoTooltipContent?: React.ReactNode;
  wrapperClassName?: string;
  "data-testid"?: string;
}

const ValuesScale: React.FC<ValuesScaleProps> = ({
  items,
  selectedValue,
  title,
  infoTooltipContent,
  wrapperClassName = "",
  "data-testid": dataTestId,
}) => {
  const displayItems = items?.slice(0, MAX_VALUES_SCALE_SEGMENTS) ?? [];
  const segmentColors = SCALE_COLOR_MAP[displayItems?.length ?? 0] ?? [];
  const hasSelection = selectedValue !== undefined;

  return (
    <div
      className={ClassNames("values-scale", wrapperClassName)}
      data-testid={dataTestId}
    >
      {!!title && (
        <div className="values-scale-header">
          <span className="values-scale-title">{title}</span>
          {!!infoTooltipContent && (
            <Tooltip type="info" content={infoTooltipContent}>
              <i className="seem-icon seem-icon-info values-scale-info-icon" />
            </Tooltip>
          )}
        </div>
      )}
      <div className="values-scale-segments">
        {displayItems.map((item, index) => {
          const isSelected = hasSelection && item === selectedValue;
          const isInactive = hasSelection && item !== selectedValue;

          return (
            <div
              key={`${item}-${index}`}
              className={ClassNames("values-scale-segment", {
                "is-selected": isSelected,
                "is-inactive": isInactive,
              })}
            >
              <div
                className="values-scale-bar"
                style={
                  !isInactive
                    ? { backgroundColor: segmentColors[index] }
                    : undefined
                }
              />
              <span className="values-scale-label">{item}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ValuesScale;
